import React from 'react'
import dompurify from 'dompurify'
import '@progress/kendo-theme-default/dist/all.css'
import { Dialog } from '@progress/kendo-react-dialogs'
import { useTranslation } from "react-i18next"

import htmlContent from '../../../utils/privacy'


const CustomTitleBar = (props) => {
  const { t } = useTranslation()

  const customTitleBarStyles = {
    color: '#FFFFFF',
    fontSize: '20px',
    textAlign: 'left',
    fontFamily: 'Quicksand, sans-serif',
    fontWeight: '600'
  }
  return (<div style={customTitleBarStyles}><span>{t('dialogSignRequestPure.titleDialogSignRequest')}</span></div>)
}

function DialogPrivacy(props) {
  var sanitizer = dompurify.sanitize

  return (
    <div>
      {props.modalTermsCond &&
        <Dialog title={<CustomTitleBar />} onClose={() => { props.openModalTermsCond(false) }} height={500} width={750}>
          <div style={{ width: 650, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '26' }}>
            <div dangerouslySetInnerHTML={{ __html: sanitizer(htmlContent) }} />
          </div>
        </Dialog>
      }
    </div>
  )
}
export { DialogPrivacy as default }